import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/user/user.module').then((m) => m.UserModule)
  },
  {
    path: 'mobile',
    loadChildren: () => import('./modules/mobile/mobile.module').then((m) => m.MobileModule)
  },
  {
    path: 'errors',
    loadChildren: () => import('./modules/error/error.module').then((m) => m.ErrorModule)
  },
  { path: '**', redirectTo: 'errors/404' }
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 80]
    }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
